import CaseStudiesIndex from './CaseStudiesIndex';

export default CaseStudiesIndex;
